var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M3.49658 11H12.6671",
    stroke: "#21242B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M10.166 8.49896L12.6671 11L10.166 13.501",
    stroke: "#21242B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M5.99756 8.61321V7.16511C5.99804 6.37061 6.55903 5.68681 7.33812 5.53109L16.5086 3.52526C17.0204 3.46613 17.5329 3.63052 17.9148 3.97635C18.2967 4.32217 18.511 4.81586 18.5028 5.33101V16.8358C18.503 17.3276 18.2861 17.7944 17.9102 18.1113C17.5342 18.4283 17.0374 18.5632 16.5528 18.4798L7.3823 16.9025C6.58195 16.7648 5.99718 16.0706 5.99756 15.2585V13.4769",
    stroke: "#21242B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.4a9f2fe2dd0d8da7bb42886996570d4a.svg";
export { ForwardRef as ReactComponent };